<template>
  <div>
    <p class="text-center mt-20">
      <b>{{ nameLabel }} 선택</b>
    </p>
    <p class="text-center text-666 mt-10">
      {{ multiple ? '복수 선택이 가능합니다.' : '항목을 선택하세요.' }}
    </p>
    <div class="box mt-20">
      <div class="box-header text-right text-888 pv-6">
        <span v-if="multiple">(복수 선택)</span>
        <span v-else>(단일 선택)</span>
      </div>
      <div class="box-body">
        <div class="table-responsive">
          <table class="tbl select-tbl">
            <colgroup>
              <col v-for="(col, index) in effectiveColumns" :key="index" :width="col.width || 'auto'">
            </colgroup>
            <thead class="no-drag">
              <tr>
                <th v-for="(col, index) in effectiveColumns" :key="index">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody v-if="!options || options.length === 0">
              <tr>
                <td :colspan="effectiveColumns.length" style="text-align:center">{{ emptyText }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(option, index) in options" :key="index" :class="{'selected': isSelected(option), 'disabled': isDisabled(option)}" @click="selectOption(option)" :style="isDisabled(option) ? 'cursor:not-allowed;' : 'cursor:pointer'">
                <td v-for="(col, colIndex) in effectiveColumns" :key="colIndex">
                  <div class="td-box">
                    <label class="md-check" v-if="(multiple || useCheckbox) && colIndex === 0" @click.stop>
                      <input type="checkbox" :checked="isSelected(option)" :disabled="isDisabled(option)" @change="onCheckboxChange(option)">
                      <i class="blue"></i>
                    </label>
                    <span class="td-text">{{ option[col.key] }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close" @click="cancel">
        <i class="icon-close mr-5"></i>취소</button>
      <button class="btn btn-lg success" data-dismiss="modal" aria-label="Close" @click="applySelection">
        <i class="icon-check mr-5"></i>적용</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Array, Object, String],
      default: () => null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    useCheckbox: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: () => 'name'
    },
    disabledOptions: {
      type: Array,
      default: () => []
    },
    nameLabel: {
      type: String,
      default: () => '항목'
    },
    descriptionLabel: {
      type: String,
      default: () => '내용'
    },
    emptyText: {
      type: String,
      default: () => '데이터가 없습니다.'
    },
    onSelect: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      localSelected: []
    };
  },
  computed: {
    effectiveColumns() {
      if (this.columns && this.columns.length > 0) return this.columns;
      return [
        { label: this.nameLabel, key: 'name', width: '180px' },
        { label: this.descriptionLabel, key: 'description' }
      ];
    }
  },
  watch: {
    selected: {
      handler() {
        this.initSelection();
      },
      immediate: true
    }
  },
  methods: {
    onCheckboxChange(option) {
      if (this.isDisabled(option)) return;
      this.selectOption(option);
    },
    selectOption(option) {
      if (this.isDisabled(option)) return;
      if (this.multiple) {
        this.toggleOption(option);
        return;
      }
      this.localSelected = [option];
    },
    isSelected(option) {
      if (!this.localSelected || this.localSelected.length === 0) return false;
      const value = this.getOptionValue(option);
      return this.localSelected.some((item) => this.getOptionValue(item) === value);
    },
    isDisabled(option) {
      if (!this.disabledOptions || this.disabledOptions.length === 0) return false;
      if (this.isSelected(option)) return false;
      return this.disabledOptions.includes(this.getOptionValue(option));
    },
    getOptionValue(option) {
      if (!option) return '';
      if (option[this.valueKey] != null) return option[this.valueKey];
      if (option.name != null) return option.name;
      return '';
    },
    toggleOption(option) {
      const value = this.getOptionValue(option);
      const index = this.localSelected.findIndex((item) => this.getOptionValue(item) === value);
      if (index > -1) {
        this.localSelected.splice(index, 1);
      } else {
        this.localSelected.push(option);
      }
    },
    initSelection() {
      let selectedList = [];
      if (Array.isArray(this.selected)) {
        selectedList = this.selected;
      } else if (this.selected) {
        selectedList = [this.selected];
      }
      const selectedValues = selectedList.map((item) => {
        if (typeof item === 'string') return item;
        if (item && item[this.valueKey] != null) return item[this.valueKey];
        if (item && item.name) return item.name;
        return null;
      }).filter(Boolean);
      this.localSelected = selectedValues.map((value) => {
        return this.options.find((option) => this.getOptionValue(option) === value) || { [this.valueKey]: value, name: value };
      });
    },
    applySelection() {
      if (this.onSelect) {
        if (this.multiple) {
          this.onSelect(this.localSelected);
        } else {
          this.onSelect(this.localSelected[0] || null);
        }
      }
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    }
  }
}
</script>

<style>
.tbl.select-tbl tbody tr.selected {
  background-color: #eaebec;
}
.tbl.select-tbl tbody tr.disabled {
  opacity: 0.5;
}
</style>
